import {Clp} from "../../../../../models/Clp";
import React, {FC, Fragment, useEffect, useState} from "react";
import {
    Card as MuiCard,
    CardContent as MuiCardContent,
    CardHeader as MuiCardHeader,
    Table,
    TableBody,
    TableCell as MuiTableCell,
    TableContainer,
    TableHead,
    TableRow,
    Theme,
    Typography,
    withStyles
} from "@material-ui/core";
import styled from "styled-components/macro";
import {spacing} from "@material-ui/system";
import {Box} from "@mui/material";
import {processClpData} from "../../../../../utils/functions";
import NoDataAvailable from "../../../statistic/components/widgets/components/NoDataAvailable";

const TableCell = styled(MuiTableCell)`
  outline: 1px solid rgba(81, 81, 81, 1);
  border-bottom: unset;
`

const Card = styled(MuiCard)(spacing);
const CardContent = withStyles((theme: Theme) => ({
    root: {
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            alignItems: "flex-start",
            flexDirection: "column"
        },
        padding: "16px !important"
    }
}))(MuiCardContent);
const CardHeader = withStyles((theme: Theme) => ({
    root: {
        paddingBottom: "0 !important"
    }
}))(MuiCardHeader);

type PropsType = {
    data: Clp[] | null
}

const IssuesByCostLevelWidget: FC<PropsType> = ({ data }) => {
    const [rows, setRows] = useState<any[]>([])

    useEffect(() => {
        if (data && data.length > 0) {
            generateData(data)
        }
    }, [data]);

    const generateData = (data: Clp[]) => {
        const generateRows = (data: Clp[]) => {
            const collections: { x1: any, x2: any, x3: any, x4: any, x5: any } [] = []
            if (data.length > 0) {
                let data1 = processClpData(data.filter((item) => item.price_level === 1))
                let data2 = processClpData(data.filter((item) => item.price_level === 2))
                let data3 = processClpData(data.filter((item) => item.price_level === 3))
                let data4 = processClpData(data.filter((item) => item.price_level === 4))
                let data5 = processClpData(data.filter((item) => item.price_level === 5))
                const maxLength = Math.max(data1.length, data2.length, data3.length, data4.length, data5.length);

                const getCell = (clp: Clp) => (
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <Typography>{clp.name}</Typography>
                        <Typography>{clp.count}</Typography>
                    </Box>
                )
                for (let i = 0; i < maxLength; i++) {
                    collections.push({
                        x1: data1 && data1[i] ? getCell(data1[i]) : '',
                        x2: data2 && data2[i] ? getCell(data2[i]) : '',
                        x3: data3 && data3[i] ? getCell(data3[i]) : '',
                        x4: data4 && data4[i] ? getCell(data4[i]) : '',
                        x5: data5 && data5[i] ? getCell(data5[i]) : '',
                    })
                }
            }
            return collections
        }

        const newRows = []

        const mandatory = data.filter((i) => i.is_mandatory)
        const recommended = data.filter((i) => !i.is_mandatory)
        if (mandatory.length > 0) {
            newRows.push({ name: 'Mandatory', elements: generateRows(mandatory)})
        }
        if (recommended.length > 0) {
            newRows.push({ name: 'Recommended', elements: generateRows(recommended) })
        }

        setRows(newRows.map((row, index) => (
            <Fragment key={index}>
                <TableRow>
                    <TableCell align={'center'} rowSpan={row.elements.length + 1}>
                        <Typography style={{fontWeight: 600}}>{row.name}</Typography>
                    </TableCell>
                </TableRow>
                {row.elements.map((element, elIndex) => (
                    <TableRow key={elIndex}>
                        <TableCell>{element.x1}</TableCell>
                        <TableCell>{element.x2}</TableCell>
                        <TableCell>{element.x3}</TableCell>
                        <TableCell>{element.x4}</TableCell>
                        <TableCell>{element.x5}</TableCell>
                    </TableRow>
                ))}
            </Fragment>
        )))
    }

    return (
        <Card style={{position: 'relative'}}>
            <CardHeader title={'Issues by cost level'}/>
            <CardContent>
                <TableContainer>
                    <Table style={{tableLayout: 'fixed'}}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Cost level</TableCell>
                                <TableCell align="center">{'1'}</TableCell>
                                <TableCell align="center">{'2'}</TableCell>
                                <TableCell align="center">{'3'}</TableCell>
                                <TableCell align="center">{'4'}</TableCell>
                                <TableCell align="center">{'5'}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell>
                                    <Box display={'flex'} justifyContent={'space-between'}>
                                        <Typography style={{fontWeight: 600}}>Name</Typography>
                                        <Typography style={{fontWeight: 600}}>Nbr</Typography>
                                    </Box>
                                </TableCell>
                                <TableCell>
                                    <Box display={'flex'} justifyContent={'space-between'}>
                                        <Typography style={{fontWeight: 600}}>Name</Typography>
                                        <Typography style={{fontWeight: 600}}>Nbr</Typography>
                                    </Box>
                                </TableCell>
                                <TableCell>
                                    <Box display={'flex'} justifyContent={'space-between'}>
                                        <Typography style={{fontWeight: 600}}>Name</Typography>
                                        <Typography style={{fontWeight: 600}}>Nbr</Typography>
                                    </Box>
                                </TableCell>
                                <TableCell>
                                    <Box display={'flex'} justifyContent={'space-between'}>
                                        <Typography style={{fontWeight: 600}}>Name</Typography>
                                        <Typography style={{fontWeight: 600}}>Nbr</Typography>
                                    </Box>
                                </TableCell>
                                <TableCell>
                                    <Box display={'flex'} justifyContent={'space-between'}>
                                        <Typography style={{fontWeight: 600}}>Name</Typography>
                                        <Typography style={{fontWeight: 600}}>Nbr</Typography>
                                    </Box>
                                </TableCell>
                            </TableRow>
                            {rows}
                        </TableBody>
                    </Table>
                </TableContainer>
                <NoDataAvailable visible={!!(data && data.length === 0)}/>
            </CardContent>
        </Card>
    )
}

export default IssuesByCostLevelWidget